import i18next, { t } from 'i18next';
import React from 'react';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { Card, Col, Row } from 'react-bootstrap';
import NoDataLayer from '../../../../../Common/NoDataLayer';

class ELEMENT_CONTRACT_EDP_RESUMEN extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        cardItem: [
            {
                text: t('data-lang-lbl-edpcount'),
                value: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.item !== null ?
                    this.props.inputParam_ComponentContent.item.nro_edps : '--') : '--'
            },
            {
                text: t('data-lang-lbl-lastepapproved'),
                value: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.item !== null ?
                    this.props.inputParam_ComponentContent.item.ult_nro_edp_aprobado : '--') : '--'
            },
            {
                text: t('data-lang-lbl-currentmonthep'),
                value: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.item !== null ?
                    this.props.inputParam_ComponentContent.item.mes_nro_edp : '--') : '--'
            }
        ]
    };
  }

  static propTypes = {
    inputParam_HideHeader: PropTypes.bool,
    inputParam_UseFake: PropTypes.bool,
  };

  static defaultProps = {
    inputParam_HideHeader: false,
    inputParam_UseFake: false,
  };

  renderContent() {
    return  <>
                <Row className='px-3 h-100' style={{opacity: this.props.inputParam_UseFake ? ".4" : ""}}>
                        {
                            this.state.cardItem.map((item, index) => (
                                <Col key={index} className='p-0 m-auto h-100'>
                                    <Card>
                                    <Card.Body className='h-50 p-0 m-0 text-start rounded-top' style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
                                            {item.text}
                                    </Card.Body>
                                    <div className='m-0 p-0 h-50'>
                                        <div className='text-center font-weight-bold'>{!isNaN(item.value) ? parseFloat(parseFloat(item.value).toFixed(2)).toLocaleString() : '--'}</div>
                                    </div>
                                    </Card>
                                </Col>
                            ))
                        }
                </Row>
            </>
  }

  render() {
    return (
      <>
        {this.renderContent()}
      </>
    );
  }
}

export default ELEMENT_CONTRACT_EDP_RESUMEN;